<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <b-card v-if="recordNotFound">
        <b>{{ $t("NoRecordFound") }}</b>
        <router-link :to="'/company/appointment'" class="float-right">
          <b-button variant="primary" class="primary">{{
            $t("Back")
          }}</b-button>
        </router-link>
      </b-card>
      <b-card v-else>
        <h4 class="heading">
          {{ $t("UserDetails") }}
          <a @click="$router.go(-1)">
            <b-button
              variant="primary"
              class="br-20 float-right border-primary"
              >{{ $t("Back") }}</b-button
            >
          </a>
        </h4>
        <br /><br />
        <div class="export-table mt-5 ml-2 user-detail-table">
          <div class="vx-col">
            <b-table-simple responsive>
              <b-tbody>
                <b-tr v-if="user.first_name">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{ $t("FirstName") }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span>{{ user.first_name }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="user.last_name">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{ $t("LastName") }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span>{{ user.last_name }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="user.email">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{ $t("email") }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <a :href="`mailto:${user.email}`">{{ user.email }}</a>
                  </b-td>
                </b-tr>

                <b-tr v-if="user.contact_number">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{ $t("ContactNumber") }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span>{{ user.contact_number }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="user.gender">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{ $t("gender") }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span>{{ user.gender }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="user.dob">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{ $t("dob") }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span>{{ user.dob }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="user.age">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{ $t("age") }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span>{{ user.age }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="user.country">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{ $t("country") }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span>{{ user.country }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="user.city">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{ $t("city") }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span>{{ user.city }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="user.custom_field_one">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{
                      $t("custom_field_one")
                    }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span>{{ user.custom_field_one }}</span>
                  </b-td>
                </b-tr>
                <b-tr v-if="user.custom_field_two">
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">{{
                      $t("custom_field_two")
                    }}</span>
                  </b-td>
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span>{{ user.custom_field_two }}</span>
                  </b-td>
                </b-tr>
                
              </b-tbody>
            </b-table-simple>
            <a
              href="http://"
              class="hide"
              ref="adownload"
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          </div>
        </div>
      </b-card>
    
    </b-overlay>
    <UserFile :user="user" :user_id="$route.params.id" :appointment_id="$route.query.appointment_id"></UserFile>
  </div>
</template>

<script>
import vSelect from "vue-select";
import UserFile from "@/components/User-file.vue";
import { get } from "@/api/company-users";

export default {
  props: {
    data: [String],
  },
  components: {
    vSelect, UserFile
  },
  data() {
    return {
      images: "",
      path: "",
      type: "",
      user: {},
      ext: "",
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      recordNotFound: false,
    };
  },
  created() {
    console.log(this.$route)
    this.getUsers(this.$route.params.id);
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },

  methods: {
    removed(){
      this.show=false;
    },
    catchMethod(error){
 
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     *
     * getUsers   method  for list all Appointment data
     **/
    async getUsers($id) {
      this.show = true;
      try {
        const res = await get($id);
        const user = res.data.data;
        if (user == null) {
          this.show = false;
          this.recordNotFound = true;
          return false;
        }
        this.user = user;
        this.user.question_option_field = JSON.parse(
          user.question_option_field
        );
      } catch (error) {
         this.catchMethod(error);
      }

      this.show = false;
    }
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.b-row {
  padding: 10px;
}

.image {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-image-class {
  box-shadow: 0px 0px 4px #888;
  padding: 5px;
}

.user-detail-table td {
  white-space: normal;
}

.user-detail-table td:first-child {
  min-width: 300px;
}

.user-detail-table td:nth-child(2) {
  min-width: 600px;
}

@media (max-width: 1024px) {
  .user-detail-table td:first-child {
    min-width: 250px;
  }

  .user-detail-table td:nth-child(2) {
    min-width: 400px;
  }
}

@media (max-width: 768px) {
  .user-detail-table td:first-child {
    min-width: 100px;
  }

  .user-detail-table td:nth-child(2) {
    min-width: 200px;
  }

  .user-detail-table img, iframe {
    width: 100%;
  }

  .user-detail-table iframe {
    height: 200px;
  }
}
</style>